import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./Style/common.css";
import "./Style/header.css";
import "./Style/StudyRoom.css";
import "./Style/ExploreActivities.css";
import "./Style/trophy_club.css";
import Loading from "../../Common/Loading";
import Header from "../../Common/Header";
import Section from "../../Common/Section";
import SubHeader from "../../Common/SubHeader";
// import { data } from "jquery";

type Activity = {
  ActivityNumber: string;
  FileID: string;
  ChildShortDesc: string;
  CssClassForActivity: string;
  LevelNo: number;
  Score: string;
  activitytype: string;
  lessoncode: string;
  DICFileVersion: string;
  lessonType?: string;
  yla?: boolean;
  testLessonsBlob?: boolean;
};

type Chapter = {
  ChapterCode: string;
  ChapterNumber: number;
  ChildShortDesc: string;
  activities: Activity[];
};

type Unit = {
  DICFileName: string;
  DICFileVersion: string;
  UnitCode: string;
  ChildShortDesc: string;
  CurriculumHeading?: string;
  chapters: Chapter[];
};

type GradeOption = {
  value: string;
  label: string;
  subject?: string;
};
interface ReportData {
  subject: string;
  leftArrowText: string;
  rightArrowText: string;
  bannerColor: string;
  bannerImage: string;
  containerImage: string;
  showLeftArrow: boolean;
  showRightArrow: boolean;
  redirect?: string;
}

const apiUrl = process.env.REACT_APP_DOCUMENT_LINK ;
const GRADES_PATH = "get_grade_options/";
const EXPLORE_PATH = "ExploreActivities/";

const ExploreActivities: React.FC = () => {
  const [units, setUnits] = useState<Unit[]>([]);
  const [expandedUnits, setExpandedUnits] = useState<boolean[]>([]);
  const [isLegendVisible, setIsLegendVisible] = useState(false);

  const [, setUserName] = useState<string>("");
  const [, setImageSrc] = useState("");
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [showBackToBottom, setShowBackToBottom] = useState(true);
  const scrollContainerRef = useRef<HTMLElement | null>(null);

  const [grades, setGrades] = useState<GradeOption[]>([]);
  const [selectedGrade, setSelectedGrade] = useState<string>(
    sessionStorage.getItem("SelectedDICFile") || ""
  );
  const [gradesLoadedForSubject, setGradesLoadedForSubject] = useState<string | null>(null);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [reportData, setReportData] = useState<ReportData | null>(null);
  const [isPageLoading, setIsPageLoading] = useState(true);

useEffect(() => {
  if (!reportData?.subject) {
    return;
  }

  setIsPageLoading(true);
  setUnits([]);
  setErrorMsg(null);
  setGradesLoadedForSubject(null);

  fetch(`${apiUrl}${GRADES_PATH}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      SchoolCode: sessionStorage.getItem("SchoolCode"),
      FamilyCode: sessionStorage.getItem("FamilyCode"),
      Login: sessionStorage.getItem("Login"),
      Subject: reportData.subject,
    }),
  })
    .then((res) => {
      if (!res.ok) throw new Error(`get_grade_options failed ${res.status}`);
      return res.json();
    })
    .then((data: GradeOption[]) => {
      const gradeOptions = Array.isArray(data) ? data : [];
      setGrades(gradeOptions);
      setGradesLoadedForSubject(reportData.subject);

      if (gradeOptions.length > 0) {
        const lastSelectedGrade = sessionStorage.getItem("SelectedDICFile");
        const isLastSelectionValid = lastSelectedGrade && gradeOptions.some((g) => g.value === lastSelectedGrade);
        const gradeToSelect = isLastSelectionValid ? lastSelectedGrade : gradeOptions[0].value;
        const gradeLabel = gradeOptions.find((g) => g.value === gradeToSelect)?.label || "";

        setSelectedGrade(gradeToSelect);
        sessionStorage.setItem("SelectedDICFile", gradeToSelect);
        sessionStorage.setItem("SelectedDICLabel", gradeLabel);
      } else {
        setSelectedGrade("");
        setIsPageLoading(false);
      }
    })
    .catch((err) => {
      // console.error("Error fetching grade options:", err);
      setErrorMsg("Failed to load grade options for this subject.");
      setGrades([]);
      setIsPageLoading(false);
    });
}, [reportData?.subject]);
const lastKey = useRef("");
const subjectTimeout = useRef<NodeJS.Timeout | null>(null);

useEffect(() => {
  if (
    !reportData?.subject ||
    gradesLoadedForSubject !== reportData.subject
  ) return;

  if (subjectTimeout.current) {
    clearTimeout(subjectTimeout.current);
  }

  subjectTimeout.current = setTimeout(() => {
    if (!selectedGrade || selectedGrade.trim() === "") return;

    const uniqueKey = `${reportData.subject}_${selectedGrade}`;

    if (lastKey.current === uniqueKey) return;
    lastKey.current = uniqueKey;

    async function fetchActivitiesByGrade(dicFileName: string) {
      try {
        const schoolCode = sessionStorage.getItem("SchoolCode");
        const familyCode = sessionStorage.getItem("FamilyCode");
        const login = sessionStorage.getItem("Login");
        const subject = reportData?.subject;

        const res = await fetch(`${apiUrl}${EXPLORE_PATH}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            SchoolCode: schoolCode,
            FamilyCode: familyCode,
            Login: login,
            Subject: subject,
            DicFileName: dicFileName,
          }),
        });

        if (!res.ok) {
          throw new Error(`ExploreActivities failed ${res.status}: ${res.statusText}`);
        }

        const data = await res.json();
        const safe = Array.isArray(data) ? data : [];
        setUnits(safe);
        setExpandedUnits(new Array(safe.length).fill(true));
      } catch (err: any) {
        // console.error("Error fetching activities:", err);
        setUnits([]);
        setErrorMsg(err?.message || "Failed to load activities");
      } finally {
        setIsPageLoading(false);
      }
    }

    fetchActivitiesByGrade(selectedGrade);
  }, 120);

}, [reportData?.subject, selectedGrade, gradesLoadedForSubject]);



  useEffect(() => {
    const UserName = sessionStorage.getItem("FName");
    const UserAvatar = sessionStorage.getItem("CurrentAvatar");
    if (UserName) setUserName(UserName);
    try {
      if (UserAvatar) setImageSrc(`${UserAvatar}`);
    } catch (error) {
      console.error("Error loading image:", error);
    };

    const handleClickOutside = () => setIsLegendVisible(false);
    if (isLegendVisible) {
      document.addEventListener("click", handleClickOutside);
    }

    const findScrollContainer = (): HTMLElement => {
      const candidates: (HTMLElement | null)[] = [
        (document.scrollingElement as HTMLElement) || null,
        document.getElementById("contents_math"),
        document.getElementById("main_top_container"),
        document.getElementById("contents_english"),
        document.getElementById("contents_physics"),
        document.getElementById("contents_chemistry"),
        document.getElementById("contents_biology"),
        document.body,
        document.documentElement,
      ];

      for (const el of candidates) {
        if (!el) continue;
        try {
          const style = window.getComputedStyle(el);
          const overflowY = style.overflowY;
          if (el.scrollHeight > el.clientHeight && (overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay" || overflowY === "visible")) {
            return el;
          }
        } catch (e) {
        }
      }
      return (document.scrollingElement as HTMLElement) || document.documentElement;
    };

    // detect and store the scroll container so click handlers can scroll the same element
    scrollContainerRef.current = findScrollContainer();
    const registeredContainer = scrollContainerRef.current;

    const handleScroll = () => {
      const el = (scrollContainerRef.current || registeredContainer || (document.scrollingElement as HTMLElement) || document.documentElement) as HTMLElement;
      const scrollTop = el.scrollTop;
      const innerH = el.clientHeight || window.innerHeight;
      const scrollHeight = el.scrollHeight;

      const scrollable = Math.max(0, scrollHeight - innerH);
      const TOL = 6;
      const atTop = scrollTop <= TOL;
      const atBottom = scrollTop >= Math.max(0, scrollable - TOL);
      const ratio = scrollable <= 0 ? 0 : scrollTop / scrollable;

      if (atTop) {
        setShowBackToBottom(true);
        setShowBackToTop(false);
        return;
      }

      if (atBottom) {
        setShowBackToTop(true);
        setShowBackToBottom(false);
        return;
      }

      if (ratio < 0.5) {
        setShowBackToBottom(true);
        setShowBackToTop(false);
      } else {
        setShowBackToTop(true);
        setShowBackToBottom(false);
      }
    };

    // Attach listener to detected scroll container
    try {
      if (registeredContainer) {
        registeredContainer.addEventListener("scroll", handleScroll, { passive: true });
      } else {
        window.addEventListener("scroll", handleScroll, { passive: true });
      }
    } catch (e) {
      window.addEventListener("scroll", handleScroll, { passive: true });
    }

    // run once to set initial state
    setTimeout(handleScroll, 0);

    return () => {
      document.body.classList.remove("StudyRoom-background");
      document.removeEventListener("click", handleClickOutside);
      const registeredContainer = scrollContainerRef.current;
      if (registeredContainer) {
        try {
          registeredContainer.removeEventListener("scroll", handleScroll as EventListener);
        } catch (e) {
          /* ignore */
        }
      }
      try {
        window.removeEventListener("scroll", handleScroll as EventListener);
      } catch (e) {
        /* ignore */
      }
    };
  }, [isLegendVisible]);

  const toggleUnit = (index: number) => {
    setExpandedUnits((prev) =>
      prev.map((exp, i) => (i === index ? !exp : exp))
    );
  };

  const DicCode = sessionStorage.getItem("SelectedDICFile");

// Find getActivityLink function and update it:
const getActivityLink = (activity: Activity): string => {
    const { 
      lessoncode, 
      activitytype,
      DICFileVersion,
      ChildShortDesc, 
      lessonType, 
      yla, 
      testLessonsBlob 
    } = activity;
    
    const DicCode = sessionStorage.getItem("SelectedDICFile");
    const calledFrom = "&calledFrom=" + encodeURIComponent("/STUDENT/MSR/ExploreActivities");

    const hwidParam = "&hwid=null"; 

    const dicFileVersionParam = sessionStorage.getItem("DICFileVersion") || DICFileVersion || "";

    if (activitytype === "G") {
      return `/STUDENT/Tutorials/Game?folder=${DicCode}&LsnTestCode=${lessoncode + "_E"}${calledFrom}${hwidParam}`;
    }
    if (activitytype === "T") {
      return `/STUDENT/Tutorials/ConfirmTest?DicCode=${DicCode}&LsnTestCode=${lessoncode}&DicVersion=${dicFileVersionParam}&name=${ChildShortDesc}${calledFrom}${hwidParam}`;
    }

    let tutorialUrl = `/STUDENT/Tutorials/Tutorial?id=${lessoncode + "_E"}&folder=${DicCode}&DicVersion=${dicFileVersionParam}`;
    
    if (lessonType) {
        tutorialUrl += `&type=${encodeURIComponent(lessonType)}`;
    }
    if (yla) {
        tutorialUrl += `&yla=true`;
    }
    if (testLessonsBlob) {
        tutorialUrl += `&testLessonsBlob=true`;
    }

    tutorialUrl += calledFrom + hwidParam;
    
    return tutorialUrl;
  };


  const handleStartActivity = (
    activity: Activity,
    chapterDesc: string,
    unitDesc: string,
    unitCode: string,
    chapterCode: string,
    dicVersion: string
  ) => {
    sessionStorage.setItem("LsnTestCode", activity.lessoncode || "");
    sessionStorage.setItem("ChapterName", chapterDesc || "");
    sessionStorage.setItem("UnitName", unitDesc || "");
    sessionStorage.setItem("UnitCode", unitCode || "");
    sessionStorage.setItem("ChapterCode", chapterCode || "");
    sessionStorage.setItem("DICFileVersion", dicVersion || "");
  };


  return (
    <form id="form1" className="explore-activities-page">
      <div id="main_top_container" style={{ backgroundColor:"#171717"}}>
        <Header />
        <div id="user_banner" style={{height:"98px"}}>
          <Section />
        </div>

        <a
          href="#bottom"
          className="back-to-bottom"
          onClick={(e) => {
            e.preventDefault();
            const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
            try {
              container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
            } catch {
              window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
            }
            setTimeout(() => {
              (container as any).scrollTop = (container as any).scrollHeight;
              (document.body as any).scrollTop = document.body.scrollHeight;
            }, 400);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
              try {
                container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
              } catch {
                window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
              }
              setTimeout(() => {
                (container as any).scrollTop = (container as any).scrollHeight;
                (document.body as any).scrollTop = document.body.scrollHeight;
              }, 400);
            }
          }}
          aria-label="Back to bottom"
          role="button"
          tabIndex={0}
          style={{
            opacity: showBackToBottom ? 1 : 0,
            transform: showBackToBottom ? 'translateY(0)' : 'translateY(8px)',
            display: 'block',
            cursor: 'pointer',
            zIndex: 2147483647,
            pointerEvents: showBackToBottom ? 'auto' : 'none',
            position: 'fixed',
            left: 20,
            bottom: 20,
            transition: 'opacity 240ms ease, transform 240ms ease',

       
            boxShadow: '0 6px 14px rgba(0,0,0,0.18)'
          }}
        >
          Back to Bottom
        </a>

        <a
          href="#top"
          className="back-to-top"
          onClick={(e) => {
            e.preventDefault();
            const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
            try {
              container.scrollTo({ top: 0, behavior: 'smooth' });
            } catch {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            setTimeout(() => {
              (container as any).scrollTop = 0;
              (document.body as any).scrollTop = 0;
            }, 300);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
              try {
                container.scrollTo({ top: 0, behavior: 'smooth' });
              } catch {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
              setTimeout(() => {
                (container as any).scrollTop = 0;
                (document.body as any).scrollTop = 0;
              }, 300);
            }
          }}
          aria-label="Back to top"
          role="button"
          tabIndex={0}
          style={{
            opacity: showBackToTop ? 1 : 0,
            transform: showBackToTop ? 'translateY(0)' : 'translateY(8px)',
            display: 'block',
            cursor: 'pointer',
            zIndex: 2147483647,
            pointerEvents: showBackToTop ? 'auto' : 'none',
            position: 'fixed',
            right: 20,
            bottom: 20,
            transition: 'opacity 240ms ease, transform 240ms ease',
            boxShadow: '0 6px 14px rgba(0,0,0,0.18)'
          }}
        >
          Back to Top
        </a>

        <SubHeader onDataLoaded={setReportData} ></SubHeader>
      </div>

      <div id="tool_bar">
        <div id="tool_bar_container" className="section_div">
          <select
            id="ddlGrade"
            name="grade-select"
            className="activities_grade_dropdownT"
            value={selectedGrade}
            onChange={(e) => {
              setIsPageLoading(true);
              const selectedValue = e.target.value || "";
              setSelectedGrade(selectedValue);
              sessionStorage.setItem("SelectedDICFile", selectedValue);
            }}
          >
            {grades.length === 0 ? (
              <option value=""></option>
            ) : (
              <>
                {grades.map((g) => (
                  <option key={g.value} value={g.value}>
                    {g.label}
                  </option>
                ))}
              </>
            )}
          </select>

          <div className="search_activities_sml_btn" style={{ margin: "10px 0 0 10px" }}>
            <a id="linkbtnGotoSearchActivities" href="/STUDENT/MSR/SearchActivities">
              Search for topic or lesson
            </a>
          </div>
        </div>
      </div>
      <div></div>

      <div id="contents_math" className="contents section_container">
        <div className="grade_container">
        <div className="grade_container_content">
          {isPageLoading ? (
            <Loading />
          ) : errorMsg ? (
            <div style={{ padding: 16, color: "crimson" }}>{errorMsg}</div>
          ) : units.length ? (
            units.map((unit: Unit, unitIndex: number) => (
              <div key={`${unit.UnitCode}_${unitIndex}`}>
                <div className="expand_box" onClick={() => toggleUnit(unitIndex)}>
                  <div
                    className={`contents-btn-icon ${
                      expandedUnits[unitIndex] ? "contents-collapse" : "contents-expand"
                    }`}
                  ></div>
                </div>

                <div className="unit_boxT">
                  <p className="grade_container_title">{unit.ChildShortDesc}</p>
                </div>
                <p className="grade_container_curriculum">
                  {unit.CurriculumHeading || "Australian National Curriculum"}
                </p>

                <div className={`unit_content ${expandedUnits[unitIndex] ? "expanded" : "collapsed"}`}>
                  {unit.chapters.map((chapter: Chapter) => (
                    <div key={chapter.ChapterCode} id={`content_${unitIndex + 1}`}>
                      <div className="chapter_title">
                        <p>
                          CHAPTER {chapter.ChapterNumber}: {chapter.ChildShortDesc}
                        </p>
                      </div>

                      <div className="row_container">
                        {chapter.activities.map((activity: Activity, idx: number) => (
                          <a key={idx} className="activity" href={`${getActivityLink(activity)}`} onClick={() =>handleStartActivity( activity, chapter.ChildShortDesc, unit.ChildShortDesc, unit.UnitCode, chapter.ChapterCode, unit.DICFileVersion)}>
                            <div className="activity_num" style={{ marginLeft: "15px" }}>
                              <p>{activity.ActivityNumber}</p>
                            </div>
                            <div className="last_score_percentage">
                              {activity.Score !== "-" ? (
                                <p>{activity.Score}%</p>
                              ) : (
                                <p>{activity.Score}</p>
                              )}
                            </div>
                            <div
                              className={activity.CssClassForActivity}
                              style={{
                                backgroundImage: `url(${
                                  activity.CssClassForActivity === "activity_icon_game"
                                    ? "https://www.elearnoncloud.com/STUDENT/MSR/Image/games_icon_lrg.png"
                                    : activity.CssClassForActivity === "activity_icon_lesson"
                                    ? "https://www.elearnoncloud.com/STUDENT/MSR/Image/lessons_icon_lrg.png"
                                    : "https://www.elearnoncloud.com/STUDENT/MSR/Image/tests_icon_lrg.png"
                                })`,
                              }}
                            ></div>
                            <div className="activity_name">
                              <p>{activity.ChildShortDesc}</p>
                            </div>
                          </a>
                        ))}
                      </div>
                    </div>
                  ))}
                  <div className="unit_break"></div>
                </div>
              </div>
            ))
          ) : selectedGrade ? (
            <div style={{ padding: 16 }}>No lessons found for this grade.</div>
          ) : (
            <Loading />
          )}
        </div>
        </div>
      </div>

      <div id="contents_english" className="contents section_container"></div>
      <div id="contents_physics" className="contents section_container"></div>
      <div id="contents_chemistry" className="contents section_container"></div>
      <div id="contents_biology" className="contents section_container"></div>

    </form>
  );
};

export default ExploreActivities;